var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagesX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.75H17C18.6569 5.75 20 7.09315 20 8.75V18.25C20 19.9069 18.6569 21.25 17 21.25H3C1.34315 21.25 0 19.9069 0 18.25V8.75C0 7.09315 1.34315 5.75 3 5.75ZM3 7.75C2.44772 7.75 2 8.19772 2 8.75V18.25C2 18.8023 2.44772 19.25 3 19.25H17C17.5523 19.25 18 18.8023 18 18.25V8.75C18 8.19772 17.5523 7.75 17 7.75H3Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.5C6.5 12.4665 5.7165 13.25 4.75 13.25C3.7835 13.25 3 12.4665 3 11.5C3 10.5335 3.7835 9.75 4.75 9.75C5.7165 9.75 6.5 10.5335 6.5 11.5Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 17.4715L4.545 14.4061C4.66773 14.2221 4.85474 14.1074 5.05776 14.0915C5.26078 14.0756 5.45993 14.1601 5.60383 14.3231L6.75547 15.6284L10.8537 10.9836C11.1284 10.6721 11.574 10.6721 11.8488 10.9836L17.5 17.3886V18.75H2.5V17.4715Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17391 6.66667C3.17391 4.50355 4.92746 2.75 7.09058 2.75H19.9565C22.1657 2.75 23.9565 4.54086 23.9565 6.75V14.75C23.9565 16.9591 22.1657 18.75 19.9565 18.75H19.7216V16.75H19.9565C21.0611 16.75 21.9565 15.8546 21.9565 14.75V6.75C21.9565 5.64543 21.0611 4.75 19.9565 4.75H7.09058C6.03203 4.75 5.17391 5.60812 5.17391 6.66667H3.17391Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesX2);
export default __webpack_public_path__ + "static/media/ImagesX2.937d540270ab45e6b96480d21310a4c5.svg";
export { ForwardRef as ReactComponent };